import { combineReducers } from 'redux';

import { configReducer, langReducer } from './configuration';
import loginReducer from './configuration/login/loginSlice';
import tokenHandlingReducer from './configuration/tokenHandling/tokenSlice';
import { accountApiSlice } from './features/app/api/accounts/accountApiSlice';
import { discountApiSlice } from './features/app/api/discount/discountApiSlice';
import { paymentMethodRequirementApiSlice } from './features/app/api/paymentMethodRequirements/paymentMethodRequirementApiSlice';
import { activationSummaryApiSlice } from './features/app/api/services/activationSummaryApiSlice';
import { marketplaceReducers } from './features/app/marketplaceReducers';
import { popupReducer } from './features/app/popup/popup.redux';

export const rootReducer = combineReducers({
    marketplace: marketplaceReducers,
    config: configReducer,
    lang: langReducer,
    login: loginReducer,
    popup: popupReducer,
    tokenHandling: tokenHandlingReducer,
    [accountApiSlice.reducerPath]: accountApiSlice.reducer,
    [activationSummaryApiSlice.reducerPath]: activationSummaryApiSlice.reducer,
    [discountApiSlice.reducerPath]: discountApiSlice.reducer,
    [paymentMethodRequirementApiSlice.reducerPath]: paymentMethodRequirementApiSlice.reducer,
});
